export const ErrorAlertIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="8.25" stroke="#FF7576" strokeWidth="1.5" />
		<path d="M12 11.1479L12 15.8521" stroke="#FF7576" strokeWidth="1.5" strokeLinecap="square" />
		<path d="M12 8.14795V8.34795" stroke="#FF7576" strokeWidth="1.5" strokeLinecap="square" />
	</svg>
);
